var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"googleMap",staticClass:"map-component"}),_c('section',{attrs:{"id":"map"}},[_c('div',{ref:"map",staticStyle:{"width":"100%","height":"400px"},attrs:{"id":"map"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }